import fonts from 'styles/fonts';
import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const ErrorDescription = styled('h3')<Props>({
  fontSize: fonts.size['14'],
  lineHeight: fonts.lineHeight['18'],
  marginBottom: '2rem',
  [mediaQueryBuilder(mediaQueries.max.height['169'])]: {
    fontSize: fonts.size['12'],
    lineHeight: fonts.lineHeight['16'],
    marginBottom: '0.5rem',
  },
});

export default ErrorDescription;
